if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyATCBar extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                variantIdSelect: '[name="id"]'
            }
        }
        connectedCallback() {
            this.container = this.closest(".sticky_pro_page");
            this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
            this.productFormActions = this.mainProduct.querySelector("product-form");
            this.variantData = this.getVariantData();
            this.init();
            this.select.addEventListener("change", (e) => {
                e.preventDefault();
                if (this.isUpdating) return;
                this.isUpdating = true;
              window.__preventScrollTrigger = '0';
              setTimeout(() => {
                    window.__preventScrollTrigger = '1';
                }, 2000);
                this.mainVariantSelects = this.mainProduct && this.mainProduct.querySelector("variant-selects");
                const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
                this.currentVariant = this.variantData.find(variant => variant.id === Number(selectedVariantId));
                if (this.mainVariantSelects) {
                    Array.from(this.mainVariantSelects.querySelectorAll("select, fieldset"),  (element, index) => {
                        const variantOptionVal = this.currentVariant.options[index];
                        switch (element.tagName) {
                            case "SELECT":
                                element.querySelectorAll("option").forEach(option => option.removeAttribute("selected"));
                                element.value = variantOptionVal;
                                const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                                if (selectedOption) {
                                    selectedOption.setAttribute("selected", "selected");
                                }
                                break;
                            case "FIELDSET":
                                Array.from(element.querySelectorAll("input")).forEach(radio => {
                                    radio.value === variantOptionVal && (radio.checked = !0)
                                });
                                break;
                        }
                    });
                    this.mainVariantSelects.dispatchEvent(new Event("change"));
                    this.isUpdating = false;
                } else {
                    this.isUpdating = false;
                }
                this.updateProductInfo();
                this.updateSubmitButton(true, "");
                if (this.currentVariant) {
                    this.updateSubmitButton(!this.currentVariant.available, window.variantStrings.soldOut);
                } else {
                    this.updateSubmitButton(true, "");
                }
            });
        }
        init() {
            if (!this.productFormActions) {
                this.container.classList.add("sticky_padd");
                return
            }
            this.observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    const method = entry.intersectionRatio !== 1 ? "add" : "remove";
                    this.container.classList[method]("sticky_padd");
                })
            }, {
                threshold: 1,
                rootMargin: '-80px 0px 0px 0px'
            });
            this.setObserveTarget();
            this.syncWithMainProductForm();
        }
        setObserveTarget() {
            this.observer.observe(this.productFormActions);
            this.observeTarget = this.productFormActions;
        }
        getVariantData() {
            return this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        }
        updateSubmitButton(disable = true, text) {
            const productForm = this.querySelector("#product-form-sticky-atc-bar");
            if (!productForm) return;
            const submitButton = productForm.querySelector('[name="add"]');
            if (!submitButton) return;
            const submitButtonText = submitButton.querySelector("span");
            if (disable) {
                submitButton.setAttribute('disabled', 'disabled');
                if (text) submitButtonText.textContent = text;
            } else {
                submitButton.removeAttribute('disabled');
                submitButtonText.textContent = window.variantStrings.addToCart;
            }
        }
        updateProductInfo() {
            fetch(`${this.getAttribute("data-url")}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
                .then(response => response.text())
                .then(responseText => {
                    const parsedHTML = new DOMParser().parseFromString(responseText, "text/html");
                    const quantity = this.querySelector(`#Quantity-Form-${this.sectionId}`);
                    const newQuantity = parsedHTML.querySelector(`#Quantity-Form-${this.sectionId}`);
                    if (quantity && newQuantity) {
                        quantity.innerHTML = newQuantity.innerHTML;
                    }
                    const price = this.querySelector(`#Price-${this.sectionId}`);
                    const newPrice = parsedHTML.querySelector(`#Price-${this.sectionId}`);
                    if (price && newPrice) {
                        price.innerHTML = newPrice.innerHTML;
                    }
                }).catch(error => {
                    console.error(error)
                }).finally(() => {});
        }
        syncWithMainProductForm() {
            subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (event.data.sectionId === this.mainProduct.dataset.sectionId) {
                    const variant = event.data.variant,
                        variantInput = this.querySelector('[name="id"]');
                    this.currentVariant = variant;
                    variantInput.value = variant.id;
                    this.updateProductInfo();
                    this.updateSubmitButton(true, "");
                    if (this.currentVariant) {
                        this.updateSubmitButton(!this.currentVariant.available, window.variantStrings.soldOut);
                    } else {
                        this.updateSubmitButton(true, "");
                    }
                }
            });
        }
        get select() {
            return this.querySelector("select")
        }
        get sectionId() {
            return this.dataset.originalSection || this.dataset.section
        }
    });
}